<template>
  <div class="empty-detail">
    <div class="title">暂无代理商</div>
    <div class="content">添加代理商，方便管理代理商</div>
    <div class="content">还可快速开展面对面访问、电话调查、明察暗访等调查工作</div>
    <div class="button"><el-button type="primary" @click="handleDrawer">邀请代理商</el-button></div>
  </div>
</template>

<script>
export default {
  name: 'EmptyDetail',
  props: {
    handleDrawer: Function
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.empty-detail {
  padding-top: 200px;
  @apply flex justify-center flex-col;
  .title {
    @apply text-20 font-semibold text-theme-black-850 mb-3 leading-22 m-auto;
  }
  .content {
    @apply text-medium font-normal text-theme-black-650 leading-22 m-auto;
  }
  .button {
    @apply mt-6 m-auto;
  }
}
</style>
